// The picture's caption (picture-caption DESIGN.md, 2026-10-30, revision 1).
//
// One caption per picture, in two beats: what you see, then what it says
// ("The chair is empty, the window green. Rest first, then rise."). Each beat
// is wrapped whole (`.beat { display: inline-block }`), so when both don't fit
// on one line the second starts the next one. Split after the first sentence;
// a one-sentence caption (or an older reading's four-word title) stays whole.

export function captionBeats (text) {
  const t = String(text || '').replace(/\s+/g, ' ').trim()
  if (!t) return []
  const m = t.match(/^(.+?[.!?])\s+(.+)$/)
  return m ? [m[1], m[2]] : [t]
}

// The name of a picture that opens: "Open the picture: {caption}". The
// lesson page's plate keeps its own verb ("Enlarge the picture: …").
export function openLabel (caption, verb = 'Open') {
  const c = String(caption || '').trim()
  return c ? `${verb} the picture: ${c}` : `${verb} the picture`
}
